module.exports = __webpack_public_path__ + "img/suishoupai.c90ede10.png";